var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlitzCircleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C17.5234 2 22 6.47656 22 12C22 17.5234 17.5234 22 12 22C6.47656 22 2 17.5234 2 12C2 6.47656 6.47656 2 12 2ZM13.4775 6.15625C13.4924 5.6156 12.9748 5.21621 12.4531 5.36621C12.258 5.42236 12.0942 5.54676 11.9893 5.71875L7.41309 13.1396C7.29484 13.3362 7.26151 13.5734 7.3252 13.7949C7.44935 14.2266 7.9033 14.4776 8.33496 14.3535L10.6367 13.6924L10.5439 17.8359C10.5288 18.3767 11.0457 18.7767 11.5674 18.627C11.7587 18.5719 11.9261 18.4467 12.0283 18.2793L16.6084 10.8975C16.733 10.695 16.768 10.4496 16.7021 10.2207C16.5737 9.77396 16.1098 9.51705 15.6631 9.64551L13.3848 10.3008L13.4775 6.15625Z",
    fill: "#212737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlitzCircleFilled);
export default __webpack_public_path__ + "static/media/blitz-circle-filled.0d9f555c788beef3ca2d54ced6d7f459.svg";
export { ForwardRef as ReactComponent };